import { gql } from '@apollo/client'

export const SHOP_TIP_VARIANT_FRAGMENT = gql`
  fragment ShopTipVariant on ShopTipVariant {
    amount
    amountFormatted
    id
    percentage
  }
`
